<template>
  <button
    v-if="visible"
    type="button"
    class="pwa-install"
    :class="theme === 'ghost' ? 'pwa-install--ghost' : 'pwa-install--gold'"
    title="Instalar MiStock como aplicación"
    @click="handleInstall"
  >
    <i class="fas fa-mobile-alt" aria-hidden="true"></i>
    <span>Instalar app</span>
  </button>
</template>

<script>
import Swal from "sweetalert2";
import { pwa, installPwa } from "@/utils/pwa.js";

export default {
  name: "InstallPwaButton",
  props: {
    /* gold: botón sólido para fondos claros (login). ghost: borde claro para
     * el navbar sobre fondo oscuro. */
    theme: {
      type: String,
      default: "gold",
    },
  },
  data() {
    return { pwa };
  },
  computed: {
    visible() {
      if (this.pwa.isInstalled) return false;
      return this.pwa.canInstall || this.pwa.isIos;
    },
  },
  methods: {
    async handleInstall() {
      if (this.pwa.canInstall) {
        const outcome = await installPwa();
        if (outcome === "accepted") {
          await Swal.fire({
            icon: "success",
            title: "¡MiStock instalada!",
            text: "Ábrela desde tu escritorio, menú de apps o pantalla de inicio.",
            confirmButtonText: "Listo",
          });
        }
        return;
      }

      /* iOS Safari no dispara beforeinstallprompt: guiamos al usuario. */
      if (this.pwa.isIos) {
        await Swal.fire({
          icon: "info",
          title: "Instalar MiStock en iPhone/iPad",
          html: [
            '<ol style="text-align:left;padding-left:1.25rem;margin:0;">',
            "<li>Toca el ícono de <strong>Compartir</strong> <i class=\"fas fa-share-square\"></i> en Safari.</li>",
            "<li>Elige <strong>Agregar a pantalla de inicio</strong>.</li>",
            "<li>Confirma con <strong>Agregar</strong>.</li>",
            "</ol>",
          ].join(""),
          confirmButtonText: "Entendido",
        });
      }
    },
  },
};
</script>

<style scoped>
.pwa-install {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  border-radius: 10px;
  padding: 0.55rem 1.1rem;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease,
    color 0.2s ease;
  line-height: 1.2;
}

.pwa-install i {
  font-size: 1rem;
}

.pwa-install--gold {
  border: none;
  color: #ffffff;
  background: linear-gradient(135deg, #b8860b 0%, #d4a017 50%, #e6b422 100%);
  box-shadow: 0 8px 20px rgba(204, 153, 0, 0.28);
}

.pwa-install--gold:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 28px rgba(204, 153, 0, 0.35);
}

.pwa-install--ghost {
  border: 1px solid rgba(255, 255, 255, 0.55);
  color: #ffffff;
  background: transparent;
}

.pwa-install--ghost:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: #ffffff;
}

.pwa-install--ghost i,
.pwa-install--ghost span {
  text-shadow: none;
}
</style>
